<script>
import { infoDetailsMethods, actionsMethods } from '@state/helpers'
import toggle from '@utils/design/toggle-info'

export default {
  name: 'CActionInfo',

  props: {
    action: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    actionEdit: function() {
      return { ...this.action }
    },
  },

  methods: {
    ...infoDetailsMethods,
    ...actionsMethods,

    entityChanged: function(entity) {
      this.actionEdit.entity = entity
      this.updateAction({ action: this.actionEdit })
    },

    operatorChanged: function(operator) {
      this.actionEdit.operator = operator
      this.updateAction({ action: this.actionEdit })
    },

    valueChanged: function(value) {
      this.actionEdit.value = value
      this.updateAction({ action: this.actionEdit })
    },

    typeChanged: function(type) {
      this.actionEdit.type = type
      this.updateAction({ action: this.actionEdit })
    },
    stopAction: function(type) {
      this.deleteAction({ id: this.actionEdit.id })
      toggle()
    },
  },
}
</script>

<template>
  <div>
    <b-card-body
      v-if="actionEdit"
      class="bg-info card card-body card-body-side mb-0 pl-0 pb- clearfix"
    >
      <b-row class="ml-0 mr-0 ">
        <b-col class="h5 pl-3 mb-0  text-uppercase">
          <b-card-text style="font-size:20px; font-weight:bold; padding-left:6px;">
            {{ actionEdit.type }}
            <b-button
              class="float-right"
              style="margin-top: -3px;"
              size="sm"
              variant="outline-dark"
              @click="stopAction"
            >
              STOP
            </b-button>
          </b-card-text>
        </b-col>
      </b-row>
    </b-card-body>

    <b-card-body
      v-if="actionEdit"
      class="card card-body card-body-side mb-0 pl-0 pt-2 pb-2 clearfix"
    >
      <b-row class="ml-0 mr-0 ">
        <b-col class="h5 pl-3 mb-0  text-uppercase pt-1">
          <b-card-text style="font-size:20px; font-weight:bold; padding:6px;">
            <span class="text-info">{{ actionEdit.entity }}</span>
            {{ actionEdit.operator }}
            <span class="text-info">{{ actionEdit.value }}</span>
          </b-card-text>
        </b-col>
      </b-row>
    </b-card-body>

    <b-card-body
      v-if="actionEdit"
      class="card card-body card-body-side mb-0 pl-0 pb-2 clearfix"
    >
      <b-row class="ml-0 mr-0 ">
        <b-col class="h5 pl-3 mb-0  text-uppercase">
          <b-card-text>
            <b-form-group>
              <label for="entity">When</label>
              <b-form-select
                id="selectType"
                :value="actionEdit.entity"
                class="text-uppercase"
                @change="entityChanged"
              >
                <option value="Activity">
                  Activity
                </option>
                <option value="Condition">
                  Condition
                </option>
                <option value="Cycle">
                  Cycle
                </option>
                <option value="Status">
                  Status
                </option>
                <option value="StatusDuration">
                  Status Idle Duration
                </option>
                <option value="ActivityDuration">
                  Activity Duration
                </option>
                <option value="CycleDuration">
                  Cycle Duration
                </option>
              </b-form-select>
            </b-form-group>
          </b-card-text>
        </b-col>
      </b-row>
    </b-card-body>

    <b-card-body
      v-if="actionEdit"
      class="card card-body card-body-side mb-0 pl-0 pb-2 clearfix"
    >
      <b-row class="ml-0 mr-0 ">
        <b-col class="h5 pl-3 mb-0  text-uppercase">
          <b-card-text>
            <b-form-group>
              <label for="selectType">Is</label>
              <b-form-select
                id="selectType"
                :value="actionEdit.operator"
                class="text-uppercase"
                @change="operatorChanged"
              >
                <option value="Equal">
                  Equal
                </option>
                <option value="Contains">
                  Contains
                </option>
                <option value="LessThanOrEqual">
                  Less Than Or Equal
                </option>
                <option value="LessThan">
                  Less Than
                </option>
                <option value="GreaterThan">
                  Greater Than
                </option>
                <option value="GreaterThanOrEqual">
                  Greater Than Or Equal
                </option>
              </b-form-select>
            </b-form-group>
          </b-card-text>
        </b-col>
      </b-row>
    </b-card-body>

    <b-card-body
      v-if="actionEdit"
      class="card card-body card-body-side mb-0 pl-0 pb-2 clearfix"
    >
      <b-row class="ml-0 mr-0 ">
        <b-col class="h5 pl-3 mb-0  text-uppercase">
          <b-card-text>
            <b-form-group>
              <label for="entity">What</label>
              <b-form-input
                id="entity"
                type="text"
                :placeholder="actionEdit.value"
                class="text-uppercase"
                @change="valueChanged"
              ></b-form-input>
            </b-form-group>
          </b-card-text>
        </b-col>
      </b-row>
    </b-card-body>

    <b-card-body
      v-if="actionEdit"
      class="card card-body card-body-side mb-0 pl-0 pb-2 clearfix"
    >
      <b-row class="ml-0 mr-0 ">
        <b-col class="h5 pl-3 mb-0  text-uppercase">
          <b-card-text>
            <b-form-group>
              <label for="entity">Then</label>
              <b-form-select
                id="selectType"
                :value="actionEdit.type"
                class="text-uppercase bg-info"
                @change="typeChanged"
              >
                <option value="SMS">
                  SMS
                </option>
                <option value="EMAIL">
                  Email
                </option>
                <option value="INSIGHT">
                  Insight
                </option>
              </b-form-select>
            </b-form-group>
          </b-card-text>
        </b-col>
      </b-row>
    </b-card-body>
  </div>
</template>

<style>
.card-body-side {
  border-radius: 0px !important;
}
.tab-content {
  border-radius: 0px !important;
}
</style>
